export enum MobilePanelPosition {
  Small = 1,
  Opened = 2,
  Max = 3,
}
